<script>
    import { getContext, createEventDispatcher } from 'svelte';
    import { SupportModal, supportModalOptions } from 'components/SupportModal';
    import { ApplicationStatusModal, applicationStatusModalOptions } from 'components/ApplicationStatusModal';
    import { PaymentModal, paymentModalOptions } from 'components/PaymentModal';

    const dispatch = createEventDispatcher();

    const { open } = getContext('simple-modal');

    export let activeLink = '';

    let showMobileNavOverlay = false;

    function showApplicationModal(onConfirm) {
        open(
            ApplicationStatusModal,
            {
                onConfirm: onConfirm,
            },
            applicationStatusModalOptions
        );
    }

    function showPaymentModal() {
        open(PaymentModal, {}, paymentModalOptions);
    }
</script>

<nav class="fixed left-0 top-0 z-[100] w-full bg-[#007ECA] px-6 py-3 shadow-lg">
    <div class="flex items-center justify-between">
        <!-- Logo -->
        <a href="/" class="flex-shrink-0 cursor-pointer">
            <img class="block h-[45px]" src={`/images/nav_logo_white@2x.png`} height="45" alt="Standard Credit Logo" />
        </a>

        <!-- Desktop Navigation Links -->
        <div class="hidden flex-1 items-center justify-center gap-x-5 text-white md:flex lg:gap-x-6">
            <button
                class="hover:text-white/80 transition-colors"
                on:click={() => {
                    showApplicationModal(() => {
                        dispatch('register', {});
                    });
                }}
            >
                Loans
            </button>
            <button
                class="hover:text-white/80 transition-colors"
                on:click={() => {
                    showApplicationModal(() => {
                        window.open('https://mytfshop.com', '_blank');
                    });
                }}
            >
                Shop
            </button>
            <a href="https://wellness.mytermfinance.com" target="_blank" class="hover:text-white/80 transition-colors">
                Wellness
            </a>
            <button
                class="hover:text-white/80 transition-colors {activeLink === 'hpcustomers' ? 'font-bold border-b-2 border-white' : ''}"
                on:click={() => {
                    dispatch('hpcustomers', {});
                }}
            >
                HP Customers
            </button>
            <button
                class="hover:text-white/80 transition-colors {activeLink === 'servicewarranties' ? 'font-bold border-b-2 border-white' : ''}"
                on:click={() => {
                    dispatch('servicewarranties', {});
                }}
            >
                Service & Warranties
            </button>
            <button
                class="hover:text-white/80 transition-colors"
                on:click={() => {
                    open(SupportModal, {}, supportModalOptions);
                }}
            >
                Contact us
            </button>
        </div>

        <!-- Desktop Action Buttons -->
        <div class="hidden items-center gap-x-2 md:flex">
            <button
                class="flex-shrink-0 rounded-full bg-white px-4 py-1.5 text-xs font-semibold text-[#007ECA] transition-all hover:bg-white/20 hover:text-white"
                on:click={showPaymentModal}
            >
                Make Payment
            </button>
            <button
                class="flex-shrink-0 rounded-full bg-white px-4 py-1.5 text-xs font-semibold text-[#007ECA] transition-all hover:bg-white/20 hover:text-white"
                on:click={() => {
                    dispatch('login', {});
                }}
            >
                Log in
            </button>
        </div>

        <!-- Mobile Menu Button -->
        <button
            class="inline-block cursor-pointer text-white md:hidden"
            on:click={() => {
                showMobileNavOverlay = !showMobileNavOverlay;
            }}
        >
            <i
                class="fa-solid fa-xl"
                class:fa-bars={!showMobileNavOverlay}
                class:fa-x={showMobileNavOverlay}
            ></i>
        </button>
    </div>
</nav>

<!-- Mobile Menu Overlay -->
{#if showMobileNavOverlay}
    <div
        class="animate__animated animate__faster animate__fadeIn fixed left-0 top-0 z-50 flex h-screen w-screen flex-col items-center justify-center gap-y-6 bg-[#007ECA] text-2xl text-white"
    >
        <button
            class="cursor-pointer"
            on:click={() => {
                showMobileNavOverlay = false;
                showApplicationModal(() => {
                    dispatch('register', {});
                });
            }}
        >
            Loans
        </button>
        <button
            class="cursor-pointer"
            on:click={() => {
                showMobileNavOverlay = false;
                showApplicationModal(() => {
                    window.open('https://mytfshop.com', '_blank');
                });
            }}
        >
            Shop
        </button>
        <a href="https://wellness.mytermfinance.com" target="_blank">Wellness</a>
        <button
            class="cursor-pointer"
            on:click={() => {
                showMobileNavOverlay = false;
                dispatch('hpcustomers', {});
            }}
        >
            HP Customers
        </button>
        <button
            class="cursor-pointer"
            on:click={() => {
                showMobileNavOverlay = false;
                dispatch('servicewarranties', {});
            }}
        >
            Service & Warranties
        </button>
        <button
            class="cursor-pointer"
            on:click={() => {
                showMobileNavOverlay = false;
                open(SupportModal, {}, supportModalOptions);
            }}
        >
            Contact us
        </button>
        <button
            class="mt-4 flex-shrink-0 rounded-full bg-white px-12 py-4 text-xl font-semibold text-[#007ECA] transition-all hover:bg-white/90"
            on:click={() => {
                showMobileNavOverlay = false;
                showPaymentModal();
            }}
        >
            Make Payment
        </button>
        <button
            class="flex-shrink-0 rounded-full bg-white px-12 py-4 text-xl font-semibold text-[#007ECA] transition-all hover:bg-white/90"
            on:click={() => {
                showMobileNavOverlay = false;
                dispatch('login', {});
            }}
        >
            Log in
        </button>
    </div>
{/if}

<style lang="scss">
    @use 'src/sass/base' as *;
    @use 'src/sass/tailwind';
</style>
